import { useTranslation } from '@web_opxp/features';
import { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ChallengeSelectors } from '../../challenge';
import { TChallengeWorkoutStatus } from '../../challenge/types';
import { CHALLENGE_LIST_SIZE } from '../constants';
import { getCurrentProgressPage } from '../utils';
import ChallengeProgressCard from './ChallengeProgressCard';
import ChallengeProgressFooter from './ChallengeProgressFooter';

export default function ChallengeProgress() {
  const { t } = useTranslation();
  const challengeProgress = useSelector(ChallengeSelectors.getChallengeProgressStatus);
  const [page, setPage] = useState(1);
  const challengeLength = challengeProgress.length;
  useEffect(() => {
    const currentPage = getCurrentProgressPage(challengeProgress);
    setPage(currentPage);
  }, [setPage, challengeProgress]);
  const progressEntries = [...challengeProgress];
  const finalProgress = progressEntries.pop() ?? 'final-future';
  const currentProgress: ReactNode[] = [];
  const currentSlice = progressEntries.slice((page - 1) * CHALLENGE_LIST_SIZE, page * CHALLENGE_LIST_SIZE);
  for (let index = 0; index < CHALLENGE_LIST_SIZE; index++) {
    const empty = currentSlice.length <= index;
    const status: TChallengeWorkoutStatus = empty ? 'empty' : currentSlice[index];
    const count = (page - 1) * CHALLENGE_LIST_SIZE + index + 1;
    const cardTitle = empty
      ? ' '
      : t('ChallengeLeaderboard.Progress.CardTitle', {
          count,
          total: challengeLength,
        });
    currentProgress.push(<ChallengeProgressCard key={count} label={cardTitle} type={status} />);
  }
  const finalCardTitle = t('ChallengeLeaderboard.Progress.CardTitle', {
    count: challengeLength,
    total: challengeLength,
  });
  return (
    <>
      <div className="challenge-highscores">
        {currentProgress}
        <div className="highscores-spacer">...</div>
        <ChallengeProgressCard label={finalCardTitle} type={finalProgress} />
      </div>
      <ChallengeProgressFooter page={page} total={progressEntries.length} onPageChange={setPage} />
    </>
  );
}
